import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";



const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));




export default function ConsultasProximasListar() {
    const classes = useStyles();

    const [consultas, setConsultas] = useState([]);
    const [lista, setLista] = useState([]);
    const [loading, setLoading] = React.useState(false);

    useEffect(()=>{
        setLoading(true)
        api.get('/consulta/proxima').then(res=>{
            if(res.data.code===0){
                setConsultas(res.data.data)
                setLista(res.data.data)
            }
            setLoading(false)
        })

    }, [])

    function pesquisa(e) {
        // eslint-disable-next-line array-callback-return
        let temp =lista.filter(value => {
            if((!value.fornecedor.nome.toLowerCase().indexOf(e.target.value.toLowerCase(), -1))){
                return value;
            }
        })
        setConsultas(temp)
    }

    const columns = [
        {
            name: "Cliente",
            selector: "nomeCliente",
            sortable: true
        },
        {
            name:"Animal",
            selector: "nomeAnimal",
            sortable: true
        },
        {
            name:"Data",
            selector: 'data',
            sortable: true
        },
        {
            name: "Ver",
            cell: row=><Link to={"/consulta/"+row.id}><Button variant={"contained"} color={"primary"}>Aceder a consulta</Button></Link>
        }
    ];



    return (
        <Container component="main" maxWidth="md">
            <TextField label="Pesquisa" onChange={pesquisa}/>
            <div className={classes.paper}>
                <DataTable
                    title="Proximas consultas"
                    columns={columns}
                    data={consultas}
                    sortIcon={<SortIcon />}
                    pagination
                    selectableRowsComponent={Checkbox}
                    contextMessage={{
                        singular: 'artigo',
                        plural: 'artigos',
                        message: 'selecionada\\s' }}
                    noDataComponent={"Não foi encontrados clientes"}
                    progressPending={loading}
                    progressComponent={<CircularProgress />}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Linhas por pagina:',
                        rangeSeparatorText: 'de',
                        noRowsPerPage: false,
                        selectAllRowsItem: false,
                        selectAllRowsItemText: 'Todas'
                    }}
                />
            </div>
        </Container>
    );
}
